module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fronttitle sans"
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("This book is based upon my experiences during psychiatry residency training. When possible, I have obtained permission from, and I have also changed names and identifying characteristics of, many of the people represented to protect their privacy. I’ve also created composite characters. Patient descriptions and patient encounters in this book have been deliberately altered to make them unidentifiable.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d456e654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 69
// module chunks = 0